<div class="etq-page ds-page">

  <!-- Toast ----------------------------------------------------------------->
  <div *ngIf="toast" class="etq-toast ds-toast" [class.etq-toast-erro]="toast.tipo === 'erro'"
       [class.ds-toast--danger]="toast.tipo === 'erro'" [class.ds-toast--success]="toast.tipo === 'ok'">
    {{ toast.msg }}
  </div>

  <!-- Header bar ----------------------------------------------------------->
  <header class="etq-header ds-page-header">
    <div class="ds-page-header-icon" aria-hidden="true"><span class="etq-header-mark"></span></div>
    <div class="etq-header-left ds-page-header-copy">
      <h1 class="etq-titulo ds-page-title">Configuração de Etiquetas</h1>
      <p class="ds-page-subtitle">Configure layouts, medidas e impressão de etiquetas</p>
    </div>
    <div class="etq-header-right ds-page-actions">
      <button class="bt-novo" type="button" (click)="novaConfig()" title="Nova etiqueta">
        Nova
      </button>
      <button class="bt-excluir" type="button"
              (click)="excluir()" *ngIf="codconfigAtual" title="Excluir">
        Excluir
      </button>
      <button class="ds-btn bt-secundario bt-sem-icone" type="button"
              *ngIf="dados.logo?.mostrar"
              [class.etq-btn-logo-oculta]="!logoVisivelImpressao"
              (click)="logoVisivelImpressao = !logoVisivelImpressao; atualizarPreview()"
              [title]="logoVisivelImpressao ? 'Clique para ocultar a logo na impressão' : 'Clique para mostrar a logo na impressão'">
        {{ logoVisivelImpressao ? '🖼 Logo visível' : '🚫 Logo oculta' }}
      </button>
      <button class="bt-pdf bt-secundario" type="button" (click)="imprimirPdf()"
              title="Gerar arquivo PDF para salvar ou enviar">
        Exportar PDF
      </button>
      <button class="bt-imprimir bt-secundario" type="button" (click)="imprimir()" [disabled]="imprimindo"
              title="Imprimir diretamente — respeita exatamente as dimensões configuradas">
        Imprimir
      </button>
      <button class="bt-salvar" type="button" (click)="salvar()" [disabled]="salvando"><app-loading-indicator *ngIf="salvando" size="inline"></app-loading-indicator>
        {{ salvando ? 'Salvando...' : 'Salvar' }}
      </button>
    </div>
  </header>

  <div class="etq-body">

    <!-- Painel esquerdo: lista de configs ---------------------------------->
    <aside class="etq-aside">
      <div class="etq-aside-title">Etiquetas salvas</div>
      <div class="etq-lista" *ngIf="configs.length; else semConfigs">
        <button *ngFor="let c of configs" type="button"
                class="etq-lista-item"
                [class.ativo]="c.codconfig === codconfigAtual"
                (click)="abrirConfig(c.codconfig)">
          <span class="etq-lista-nome">{{ c.nome }}</span>
          <span class="etq-lista-tamanho">{{ (c.larguraMm / 10) | number:'1.0-1' }}×{{ (c.alturaMm / 10) | number:'1.0-1' }} cm</span>
        </button>
      </div>
      <ng-template #semConfigs>
        <p class="etq-vazio">Nenhuma etiqueta. Clique em "+ Nova".</p>
      </ng-template>
    </aside>

    <!-- Painel central: editor ------------------------------------------->
    <section class="etq-editor">

      <!-- Configurações da etiqueta ----------------------------------------->
      <div class="etq-meta ds-card">

        <!-- Linha 1: dimensões + margens -->
        <div class="etq-meta-row">
          <div class="etq-meta-group">
            <div class="etq-meta-field etq-meta-nome">
              <label>Nome</label>
              <input type="text" [(ngModel)]="nome" placeholder="Nome da etiqueta">
            </div>
            <div class="etq-meta-field etq-meta-size">
              <label>Largura (cm)</label>
              <input type="number" [(ngModel)]="larguraCm" (ngModelChange)="atualizarPreview()" min="2" max="50" step="0.1">
            </div>
            <div class="etq-meta-field etq-meta-size">
              <label>Altura (cm)</label>
              <input type="number" [(ngModel)]="alturaCm" (ngModelChange)="atualizarPreview()" min="1" max="30" step="0.1">
            </div>
          </div>

          <div class="etq-meta-margens">
            <div class="etq-meta-margens-label">Margens (mm)</div>
            <div class="etq-meta-margens-grid">
              <label class="etq-marg-field">
                <span>Superior</span>
                <input type="number" [(ngModel)]="dados.margens.superior" (ngModelChange)="atualizarPreview()" min="0" max="20" step="0.5">
              </label>
              <label class="etq-marg-field">
                <span>Inferior</span>
                <input type="number" [(ngModel)]="dados.margens.inferior" (ngModelChange)="atualizarPreview()" min="0" max="20" step="0.5">
              </label>
              <label class="etq-marg-field">
                <span>Esquerda</span>
                <input type="number" [(ngModel)]="dados.margens.esquerda" (ngModelChange)="atualizarPreview()" min="0" max="20" step="0.5">
              </label>
              <label class="etq-marg-field">
                <span>Direita</span>
                <input type="number" [(ngModel)]="dados.margens.direita" (ngModelChange)="atualizarPreview()" min="0" max="20" step="0.5">
              </label>
            </div>
          </div>

          <div class="etq-meta-logo-toggle">
            <div class="etq-meta-margens-label">Logo</div>
            <label class="etq-toggle">
              <input type="checkbox" [(ngModel)]="dados.logo.mostrar" (ngModelChange)="atualizarPreview()">
              <span class="etq-toggle-label">{{ dados.logo.mostrar ? 'Sim' : 'Não' }}</span>
            </label>
          </div>

          <!-- Rotação de impressão (salvo no config) -->
          <div class="etq-meta-logo-toggle">
            <div class="etq-meta-margens-label">Rotação</div>
            <select class="etq-select-rotacao" [(ngModel)]="dados.rotacaoImpressao" (ngModelChange)="atualizarPreview()"
                    title="Ajuste se a etiqueta sair girada ou invertida na impressora">
              <option [ngValue]="0">Normal</option>
              <option [ngValue]="90">90° ↺  (vira papel p/ direita p/ ler)</option>
              <option [ngValue]="180">180°  (conteúdo invertido)</option>
              <option [ngValue]="270">90° ↻  (vira papel p/ esquerda p/ ler)</option>
            </select>
          </div>
        </div>

        <!-- Linha 2: configurações de logo (visível só quando logo ativo) -->
        <div class="etq-printer-row ds-filter-bar">
          <div class="etq-printer-status" [class.etq-printer-online]="qzConectado">
            <span class="etq-printer-dot"></span>
            {{ qzConectado ? 'QZ conectado' : 'Impressao local' }}
          </div>
          <label class="etq-printer-select">
            <span>Impressora</span>
            <select [(ngModel)]="impressoraSelecionada" (ngModelChange)="salvarImpressoraSelecionada()"
                    [disabled]="qzConectando || !impressoras.length">
              <option value="">Selecione uma impressora</option>
              <option *ngFor="let impressora of impressoras" [value]="impressora.nome">
                {{ impressora.nome }}{{ impressora.padrao ? ' (padrao)' : '' }}
              </option>
            </select>
          </label>
          <label class="etq-printer-mode">
            <span>Modo</span>
            <select [(ngModel)]="modoImpressaoLocal" (ngModelChange)="salvarModoImpressao()">
              <option value="imagem">Imagem fiel ao preview</option>
              <option value="zpl" [disabled]="!impressoraSuportaZpl">ZPL nativo (texto mais nitido)</option>
              <option value="html">HTML (compatibilidade)</option>
            </select>
          </label>
          <button type="button" class="etq-btn etq-btn-small" (click)="buscarImpressoras()" [disabled]="qzConectando"><app-loading-indicator *ngIf="qzConectando" size="inline"></app-loading-indicator>
            {{ qzConectando ? 'Buscando...' : 'Buscar impressoras' }}
          </button>
          <a *ngIf="!qzConectado && qzInstalado !== false" class="etq-btn etq-btn-small etq-qz-launch" href="qz:launch"
             (click)="rebuscarQzAposAbrir()">Abrir QZ Tray</a>
          <a *ngIf="qzInstalado === false" class="etq-btn etq-btn-small etq-qz-download"
             href="https://qz.io/download/" target="_blank" rel="noopener noreferrer">Baixar QZ Tray</a>
          <div class="etq-printer-media">
            Papel enviado: <strong>{{ largura }} x {{ altura }} mm</strong>
            <span> | Modo: {{ modoImpressaoLocal === 'imagem' ? 'Imagem fiel' : (modoImpressaoLocal === 'zpl' && impressoraSuportaZpl ? 'ZPL nativo' : 'HTML') }}</span>
            <span *ngIf="impressoraAtual?.densidade"> | DPI: {{ impressoraAtual?.densidade }}</span>
            <span *ngIf="impressoraAtual?.driver"> | {{ impressoraAtual?.driver }}</span>
          </div>
        </div>

        <div class="etq-meta-row etq-meta-logo-row" *ngIf="dados.logo.mostrar">
          <div class="etq-meta-field etq-meta-logoalign">
            <label>Alinhamento</label>
            <select [(ngModel)]="dados.logo.alinhamento" (ngModelChange)="atualizarPreview()">
              <option value="esquerda">Esquerda</option>
              <option value="centro">Centro</option>
              <option value="direita">Direita</option>
            </select>
          </div>
          <div class="etq-meta-field etq-meta-size">
            <label>Largura (%)</label>
            <input type="number" [(ngModel)]="dados.logo.larguraPct" (ngModelChange)="atualizarPreview()" min="5" max="100">
          </div>
          <div class="etq-meta-field etq-meta-size">
            <label>Altura (mm)</label>
            <input type="number" [(ngModel)]="dados.logo.alturaMm" (ngModelChange)="atualizarPreview()" min="0" max="50" placeholder="auto">
          </div>
          <div class="etq-meta-field etq-meta-size">
            <label>Espaço acima (mm)</label>
            <input type="number" [(ngModel)]="dados.logo.margemTopMm" (ngModelChange)="atualizarPreview()" min="0" max="30" step="0.5">
          </div>
          <div class="etq-meta-field etq-meta-size">
            <label>Espaço abaixo (mm)</label>
            <input type="number" [(ngModel)]="dados.logo.margemBottomMm" (ngModelChange)="atualizarPreview()" min="0" max="30" step="0.5">
          </div>
        </div>

      </div>

      <!-- Linhas ---------------------------------------------------------->
      <div class="etq-linhas-header">
        <span>Linhas da etiqueta</span>
        <button type="button" class="etq-btn etq-btn-small etq-btn-primary" (click)="adicionarLinha()">
          + Adicionar linha
        </button>
      </div>

      <div class="etq-linhas" *ngIf="dados.linhas.length; else semLinhas">
        <div *ngFor="let linha of dados.linhas; let i = index"
             class="etq-linha-card"
             [class.etq-linha-ativa]="linhaSelecionadaId === linha.id"
             [class.etq-dragging]="dragLinhaIdx === i"
             [class.etq-drag-over]="dragOverIdx === i && dragLinhaIdx !== i"
             draggable="true"
             (dragstart)="onDragStart(i)"
             (dragover)="onDragOver($event, i)"
             (drop)="onDrop(i)"
             (dragend)="onDragEnd()">

          <div class="etq-linha-header">
            <div class="etq-linha-header-left">
              <span class="etq-drag-handle" title="Arrastar para reordenar">⠿</span>
              <span class="etq-linha-num">Linha {{ i + 1 }}</span>
              <label class="etq-linha-altura-wrap" title="Altura fixa da linha em mm (0 = automático)">
                <span class="etq-linha-altura-label">H:</span>
                <input type="number" class="etq-linha-altura-input"
                       [(ngModel)]="linha.alturaLinha"
                       (ngModelChange)="atualizarPreview()"
                       min="0" max="50" placeholder="auto">
                <span class="etq-linha-altura-unit">mm</span>
              </label>
              <label class="etq-linha-altura-wrap" title="Margem superior da linha em mm">
                <span class="etq-linha-altura-label">↑:</span>
                <input type="number" class="etq-linha-altura-input"
                       [(ngModel)]="linha.margemTopMm"
                       (ngModelChange)="atualizarPreview()"
                       min="0" max="30" step="0.5" placeholder="0">
                <span class="etq-linha-altura-unit">mm</span>
              </label>
            </div>
            <div class="etq-linha-acoes">
              <button type="button" class="etq-icon-btn" (click)="moverLinhaAcima(i)" title="Mover para cima" [disabled]="i === 0">↑</button>
              <button type="button" class="etq-icon-btn" (click)="moverLinhaAbaixo(i)" title="Mover para baixo" [disabled]="i === dados.linhas.length - 1">↓</button>
              <button type="button" class="etq-icon-btn etq-btn-danger" (click)="removerLinha(linha.id)" title="Remover linha">✕</button>
              <button type="button" class="etq-btn etq-btn-small" (click)="adicionarCampo(linha, 'campo')">+ Campo</button>
              <button type="button" class="etq-btn etq-btn-small" (click)="adicionarCampo(linha, 'texto_livre')">+ Texto</button>
            </div>
          </div>

          <!-- Campos da linha --->
          <div class="etq-campos" *ngIf="linha.campos.length; else linhaSemCampos">
            <div *ngFor="let campo of linha.campos; let ci = index"
                 class="etq-campo-chip"
                 [class.selecionado]="campoSelecionado?.id === campo.id"
                 [class.etq-chip-oculto]="campo.oculto"
                 [class.etq-chip-dragging]="dragCampoLinhaId === linha.id && dragCampoIdx === ci"
                 [class.etq-chip-drag-over]="dragOverCampoLinhaId === linha.id && dragOverCampoIdx === ci && dragCampoIdx !== ci"
                 draggable="true"
                 (dragstart)="onDragStartCampo($event, linha.id, ci)"
                 (dragover)="onDragOverCampo($event, linha.id, ci)"
                 (drop)="onDropCampo($event, linha.id, ci)"
                 (dragend)="onDragEndCampo()"
                 (click)="selecionarCampo(linha.id, campo)">
              <span class="etq-chip-drag-handle">⠿</span>
              <span class="etq-chip-icone">{{ campo.tipo === 'campo' ? '⊞' : 'T' }}</span>
              <span class="etq-chip-label">{{ labelCampo(campo) }}</span>
              <span class="etq-chip-pct">{{ campo.larguraPct }}%</span>
              <button type="button" class="etq-chip-del" (click)="$event.stopPropagation(); removerCampo(linha, campo.id)">✕</button>
            </div>
          </div>
          <ng-template #linhaSemCampos>
            <p class="etq-linha-vazio">Adicione campos com os botões acima.</p>
          </ng-template>

        </div>
      </div>
      <ng-template #semLinhas>
        <div class="etq-vazio etq-vazio-grande">
          Clique em "+ Adicionar linha" para começar a montar a etiqueta.
        </div>
      </ng-template>

      <!-- Propriedades do campo selecionado -------------------------------->
      <div class="etq-props" *ngIf="campoSelecionado">
        <div class="etq-props-title">Propriedades do campo</div>
        <div class="etq-props-grid">

          <ng-container *ngIf="campoSelecionado.tipo === 'campo'">
            <label>Fonte</label>
            <select [(ngModel)]="campoSelecionado.fonte" (ngModelChange)="onFonteChange(campoSelecionado)">
              <option *ngFor="let f of fontes" [value]="f.nome">{{ f.label }} ({{ f.nome }})</option>
            </select>

            <label>Coluna</label>
            <select [(ngModel)]="campoSelecionado.coluna" (ngModelChange)="atualizarPreview()">
              <option *ngFor="let c of colunasParaFonte(campoSelecionado.fonte)" [value]="c.coluna">
                {{ c.coluna }} <span *ngIf="c.tipo">({{ c.tipo }})</span>
              </option>
            </select>

            <label>Label</label>
            <div class="etq-props-row">
              <label class="etq-toggle-small">
                <input type="checkbox" [(ngModel)]="campoSelecionado.mostrarLabel" (ngModelChange)="atualizarPreview()">
                Mostrar
              </label>
              <input type="text" [(ngModel)]="campoSelecionado.label"
                     (ngModelChange)="atualizarPreview()"
                     *ngIf="campoSelecionado.mostrarLabel"
                     placeholder="Ex: PN:">
            </div>
          </ng-container>

          <ng-container *ngIf="campoSelecionado.tipo === 'texto_livre'">
            <label>Texto</label>
            <input type="text" [(ngModel)]="campoSelecionado.valor" (ngModelChange)="atualizarPreview()" placeholder="Texto fixo">
          </ng-container>

          <label>Alinhamento</label>
          <div class="etq-props-row etq-align-btns">
            <button type="button"
                    [class.ativo]="campoSelecionado.alinhamento === 'esquerda'"
                    (click)="campoSelecionado.alinhamento = 'esquerda'; atualizarPreview()" title="Esquerda">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="15" y2="12"/><line x1="3" y1="18" x2="18" y2="18"/></svg>
            </button>
            <button type="button"
                    [class.ativo]="campoSelecionado.alinhamento === 'centro'"
                    (click)="campoSelecionado.alinhamento = 'centro'; atualizarPreview()" title="Centro">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="3" y1="6" x2="21" y2="6"/><line x1="6" y1="12" x2="18" y2="12"/><line x1="4" y1="18" x2="20" y2="18"/></svg>
            </button>
            <button type="button"
                    [class.ativo]="campoSelecionado.alinhamento === 'direita'"
                    (click)="campoSelecionado.alinhamento = 'direita'; atualizarPreview()" title="Direita">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="3" y1="6" x2="21" y2="6"/><line x1="9" y1="12" x2="21" y2="12"/><line x1="6" y1="18" x2="21" y2="18"/></svg>
            </button>
          </div>

          <label>Tamanho da fonte</label>
          <div class="etq-props-row">
            <input type="number" [(ngModel)]="campoSelecionado.tamanhoFonte" (ngModelChange)="atualizarPreview()" min="6" max="48" style="width:70px">
            <span style="color:#6b7280;font-size:12px">px</span>
          </div>

          <ng-container *ngIf="modoImpressaoLocal === 'zpl'; else fonteVisual">
            <label>Fonte ZPL nativa</label>
            <select [(ngModel)]="campoSelecionado.fonteZpl" (ngModelChange)="atualizarPreview()">
              <option *ngFor="let fonte of fontesZpl" [value]="fonte.codigo">
                {{ fonte.rotulo }}
              </option>
            </select>
            <div class="etq-zpl-preview-aviso">O preview aproxima a forma e a proporção da fonte interna da impressora.</div>
          </ng-container>
          <ng-template #fonteVisual>
            <label>Fonte</label>
            <select [(ngModel)]="campoSelecionado.tipografia" (ngModelChange)="atualizarPreview()">
              <option *ngFor="let fonte of tipografiasCampo" [value]="fonte.valor"
                      [style.font-family]="fonte.css" [style.font-weight]="fonte.peso">
                {{ fonte.rotulo }}
              </option>
            </select>
          </ng-template>

          <label>Estilo</label>
          <div class="etq-props-row etq-estilo-btns">
            <button type="button"
                    [class.ativo]="campoSelecionado.negrito"
                    (click)="campoSelecionado.negrito = !campoSelecionado.negrito; atualizarPreview()"
                    style="font-weight:700">B</button>
            <button type="button"
                    [class.ativo]="campoSelecionado.italico"
                    (click)="campoSelecionado.italico = !campoSelecionado.italico; atualizarPreview()"
                    style="font-style:italic">I</button>
          </div>

          <label>Largura (%)</label>
          <div class="etq-props-row">
            <input type="number" [(ngModel)]="campoSelecionado.larguraPct" (ngModelChange)="atualizarPreview()" min="10" max="100" style="width:70px">
            <span style="color:#6b7280;font-size:12px">%</span>
          </div>

          <label>Padding esq. (mm)</label>
          <div class="etq-props-row">
            <input type="number" [(ngModel)]="campoSelecionado.paddingEsqMm" (ngModelChange)="atualizarPreview()" min="0" max="20" step="0.5" style="width:70px">
            <span style="color:#6b7280;font-size:12px">mm</span>
          </div>

          <label>Padding dir. (mm)</label>
          <div class="etq-props-row">
            <input type="number" [(ngModel)]="campoSelecionado.paddingDirMm" (ngModelChange)="atualizarPreview()" min="0" max="20" step="0.5" style="width:70px">
            <span style="color:#6b7280;font-size:12px">mm</span>
          </div>

          <div class="etq-props-oculto">
            <label class="etq-props-oculto-label">
              <input type="checkbox" [(ngModel)]="campoSelecionado.oculto" (ngModelChange)="atualizarPreview()">
              <span>Ocultar campo (não imprime)</span>
            </label>
          </div>

        </div>
      </div>

    </section>

    <!-- Painel direito: preview ------------------------------------------>
    <div class="etq-preview-panel">
      <div class="etq-preview-title">
        Preview
        <span class="etq-preview-dim">{{ larguraCm }}×{{ alturaCm }} cm</span>
        <span *ngIf="modoImpressaoLocal === 'zpl'" class="etq-preview-zpl">ZPL aproximado</span>
        <button class="etq-btn-tamanho-real"
                [class.ativo]="previewTamanhoReal"
                (click)="previewTamanhoReal = !previewTamanhoReal"
                title="Alternar entre ajustar ao painel e tamanho real (1mm = 3.78px)">
          {{ previewTamanhoReal ? '⊡ Ajustar' : '⊞ Tamanho real' }}
        </button>
      </div>

      <!-- Etiqueta renderizada + réguas laterais -->
      <div class="etq-preview-wrapper">

        <!-- Régua esquerda (cm verticais) — altura = label + 2×padding(4px) -->
        <div *ngIf="!previewTamanhoReal" class="etq-ruler-v" [style.height.px]="previewContainerH + 8">
          <div *ngFor="let cm of alturaRulerCms"
               class="etq-ruler-mark etq-ruler-mark-l"
               [style.top.px]="4 + cm * 10 * 3.7795 * previewScale">
            <span class="etq-ruler-num">{{ cm }}</span>
            <span class="etq-ruler-tick"></span>
          </div>
        </div>

        <!-- Preview da etiqueta -->
        <div class="etq-preview-area"
             [class.etq-preview-clickable]="!previewTamanhoReal"
             [class.etq-preview-real]="previewTamanhoReal"
             [style.width.px]="previewContainerW"
             [style.height.px]="previewContainerH"
             (click)="previewTamanhoReal ? null : abrirZoom()"
             [title]="previewTamanhoReal ? '' : 'Clique para ampliar'">
          <div class="etq-preview-label"
               [style.transform]="'scale(' + previewScale + ')'"
               [style.transformOrigin]="'top left'"
               [style.width.px]="largura * 3.7795"
               [style.height.px]="altura  * 3.7795"
               [innerHTML]="previewHtml">
          </div>
        </div>

        <!-- Régua direita (espelho da esquerda) -->
        <div *ngIf="!previewTamanhoReal" class="etq-ruler-v etq-ruler-v-r" [style.height.px]="previewContainerH + 8">
          <div *ngFor="let cm of alturaRulerCms"
               class="etq-ruler-mark etq-ruler-mark-r"
               [style.top.px]="4 + cm * 10 * 3.7795 * previewScale">
            <span class="etq-ruler-tick"></span>
            <span class="etq-ruler-num">{{ cm }}</span>
          </div>
        </div>

      </div>

      <!-- Dados reais -->
      <div class="etq-dados-reais">
        <div class="etq-dados-reais-title">
          Testar com dados reais
          <span *ngIf="dadosReais" class="etq-badge-reais">● dados carregados</span>
        </div>
        <div class="etq-dados-reais-form">
          <label class="etq-dados-campo">
            <span>Venda (NUNOTA)</span>
            <input type="number" [(ngModel)]="previewNunota" placeholder="ex: 12345" min="1">
          </label>
          <label class="etq-dados-campo">
            <span>Produto (CODPROD)</span>
            <input type="number" [(ngModel)]="previewCodprod" placeholder="ex: 24621" min="1">
          </label>
        </div>
        <div class="etq-dados-reais-actions">
          <button type="button" class="etq-btn etq-btn-primary etq-btn-small"
                  (click)="carregarDadosReais()" [disabled]="previewCarregando"><app-loading-indicator *ngIf="previewCarregando" size="inline"></app-loading-indicator>
            {{ previewCarregando ? 'Carregando...' : 'Carregar preview real' }}
          </button>
          <button type="button" class="etq-btn etq-btn-small"
                  *ngIf="dadosReais" (click)="limparDadosReais()">
            Limpar
          </button>
        </div>
        <p class="etq-preview-hint" *ngIf="!dadosReais">
          Empresa usada: {{ empresa.selecionada ?? '1' }}.<br>
          Informe NUNOTA e/ou CODPROD para ver dados reais.
        </p>
      </div>
    </div>

  </div>

  <!-- Modal zoom ---------------------------------------------------------->
  <div class="etq-zoom-overlay" *ngIf="modalZoomAberto" (click)="fecharZoom()">
    <div class="etq-zoom-modal" (click)="$event.stopPropagation()">
      <button class="etq-zoom-close" type="button" (click)="fecharZoom()" title="Fechar">✕</button>
      <div class="etq-zoom-body">
        <div class="etq-zoom-label-wrap"
             [style.width.px]="largura * 3.7795 * modalZoomScale"
             [style.height.px]="altura  * 3.7795 * modalZoomScale">
          <div class="etq-zoom-label"
               [style.transform]="'scale(' + modalZoomScale + ')'"
               [style.transformOrigin]="'top left'"
               [style.width.px]="largura * 3.7795"
               [style.height.px]="altura  * 3.7795"
               [style.overflow]="'hidden'"
               [innerHTML]="previewHtml">
          </div>
        </div>
      </div>
      <div class="etq-zoom-footer">
        {{ larguraCm }}×{{ alturaCm }} cm
        <button class="etq-btn etq-btn-small" type="button" (click)="imprimirPdf(); fecharZoom()"
                title="Exportar como PDF">
          Exportar PDF
        </button>
        <button class="etq-btn etq-btn-primary etq-btn-small" type="button" (click)="imprimir(); fecharZoom()" [disabled]="imprimindo"
                title="Imprimir diretamente — respeita exatamente as dimensões configuradas">
          🖨 Imprimir
        </button>
      </div>
    </div>
  </div>

</div>
